import { useQuery } from "@apollo/client";

import useTypedContext from "hooks/useTypedContext";
import { SavedFilter } from "types/generated";
import { AccountContext } from "views/AccountWrapper";

import { getFiltersFromSavedData } from "./SavedViews/helpers";
import { SAVED_VIEW } from "./gql";
import { SavedFilterView } from "./types";

type PermalinkView = {
  loading: boolean;
  data: SavedFilterView | undefined;
  notFound: boolean;
};

const usePermalinkView = (
  viewId: string | undefined,
  enabled: boolean,
  defaultEmptyFilterView: SavedFilterView
): PermalinkView => {
  const { viewer } = useTypedContext(AccountContext);

  const skip = !enabled || !viewId;

  const { loading, data } = useQuery<{ savedFilter: SavedFilter | null }>(SAVED_VIEW, {
    variables: {
      id: viewId,
    },
    skip,
  });

  if (skip || loading) {
    return { loading, data: undefined, notFound: false };
  }

  if (!data?.savedFilter) {
    return { loading: false, data: undefined, notFound: true };
  }

  return {
    loading: false,
    data: {
      ...getFiltersFromSavedData(data.savedFilter.data, defaultEmptyFilterView),
      id: data.savedFilter.id,
      name: data.savedFilter.name,
      isPublic: data.savedFilter.isPublic,
      isMine: data.savedFilter.createdBy === viewer.id,
    },
    notFound: false,
  };
};

export default usePermalinkView;
